import { CallAPIAction, Status } from 'api/types'
import type {
  SubmitVisaWithContractRequestResponse,
  SubmitVisaWithContractRequestFailResponse,
} from 'api/evisaAPI/visas'
import { SubmitVisaWithContractRequestError } from 'common/types/commonTypes'
import Actions from 'redux/actions'

const convertResponseToState = (resp: SubmitVisaWithContractRequestResponse) => ({
  borderNumber: resp.border_number,
  contractRequestId: resp.contract_request_id,
  visaFollow: resp.visa_follow,
  visaId: resp.visa_id,
})

type State = {
  borderNumber: number
  contractRequestId: number
  visaFollow: number
  visaId: number
  errorMessage: SubmitVisaWithContractRequestError | string
} & Status

const initialState = {
  borderNumber: 0,
  contractRequestId: 0,
  visaFollow: 0,
  visaId: 0,
  errorMessage: '',
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.SUBMIT_VISA_WITH_CONTRACT_REQUEST_ASYNC,
    Actions.SUBMIT_VISA_WITH_CONTRACT_REQUEST_SUCCESS,
    Actions.SUBMIT_VISA_WITH_CONTRACT_REQUEST_FAIL,
    SubmitVisaWithContractRequestResponse,
    SubmitVisaWithContractRequestFailResponse
  >,
): State => {
  switch (action.type) {
    case Actions.SUBMIT_VISA_WITH_CONTRACT_REQUEST_ASYNC: {
      return {
        ...state,
        ...action.status,
      }
    }
    case Actions.SUBMIT_VISA_WITH_CONTRACT_REQUEST_SUCCESS: {
      const { payload } = action
      return {
        ...state,
        ...action.status,
        ...convertResponseToState(payload),
      }
    }
    case Actions.SUBMIT_VISA_WITH_CONTRACT_REQUEST_FAIL: {
      const { payload } = action
      return {
        ...state,
        errorMessage:
          payload?.error?.message ||
          (payload?.worker_passport || payload?.worker_passport_image || [])[0] ||
          SubmitVisaWithContractRequestError.ERROR_GENERAL,
        ...action.status,
      }
    }
    default:
      return state
  }
}
